import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as paramActions from '../components/paramHistory/store/actions';
import * as lessonActions from '../content/lesson/store/actions';
import { IconButton, Icon } from '@material-ui/core';

const styles = theme => { }

class myStepper extends Component {

    newHandleClick = (lesson, index) => {
        const targetLesson = this.props.courseBuilder.completedLessons.filter(l => l.lesson_id === l.lesson_id)[0]
        this.props.saveLesson(this.props.currentLesson, this.props.currentLessonAssignmentList, this.props.currentLessonQuizList, this.props.unscheduledEventList, this.props.auth.data.auth_id, this.props.companies)
        this.props.updateCourseBuilderParams({ lessonCycleRedirect: true, lessonListIndex: index, LessonName: lesson.LessonName })
        return this.props.history.push('/lesson/edit/' + lesson.lesson_id)
    }

    handleTopMenuClick = (targetComponent) => {
        let target_id = 0
        if (this.props.baseComponent === 'course') {
            if (targetComponent === 'course') {
                return null
            }
            else {
                if (this.props.courseBuilder.completedLessons.length > 0) {
                    const targetLesson = this.props.courseBuilder.completedLessons[0]
                    this.props.updateCourseBuilderParams({ lessonCycleActive: true, LessonName: targetLesson.LessonName, lesson_id: targetLesson.lesson_id, lessonListIndex: 0 })
                    target_id = targetLesson.lesson_id
                }
                else {
                    return null
                }
            }
        }
        else if (this.props.baseComponent === 'event') {
            if (targetComponent === 'event') {
                return null
            }
            else {
                if (targetComponent === 'lesson') {
                    if (this.props.courseBuilder.startingPoint === 'lesson') {
                        target_id = this.props.courseBuilder.lesson_id;
                        this.props.updateCourseBuilderParams({ lessonCycleActive: false, LessonName: null, lesson_id: null, startingPoint: null, active: false })
                    }
                    else {
                        target_id = this.props.courseBuilder.lesson_id;
                    }
                }
                if (targetComponent === 'course') {
                    target_id = this.props.courseBuilder.course_id;
                    this.props.updateCourseBuilderParams({ lessonCycleActive: false, LessonName: null, lesson_id: null, startingPoint: null, active: false })
                }
            }
        }
        else {
            if (targetComponent === 'course') {
                this.props.updateCourseBuilderParams({ lessonCycleActive: false, LessonName: null, lesson_id: null, active: false })
                target_id = this.props.courseBuilder.course_id;
            }
            else {
                return null
            }
        }
        console.log(this.props.courseBuilder.startingPoint, this.props.courseBuilder.lesson_id, targetComponent)
        return this.props.history.push(`/${targetComponent}/edit/` + target_id)
    }

    // handleTopMenuClick = (targetComponent) => {
    //     console.log(targetComponent, this.props.baseComponent, this.props.courseBuilder.completedLessons)
    //     if (this.props.baseComponent === 'lesson' && targetComponent === 'lesson') {
    //         return null
    //     }
    //     if (this.props.baseComponent === 'course' && targetComponent === 'course') {
    //         return null
    //     }
    //     let target_id = 0;
    //     if (targetComponent === 'course') {
    //         this.props.updateCourseBuilderParams({ lessonCycleActive: false, LessonName: null, lesson_id: null })
    //         target_id = this.props.courseBuilder.course_id;
    //     }
    //     else {
    //         if (this.props.baseComponent === 'course') {
    //             console.log('here')
    //             if (this.props.courseBuilder.completedLessons.length > 0) {
    //                 console.log('here2')
    //                 target_id = this.props.courseBuilder.completedLessons[0].lesson_id
    //                 console.log(target_id)
    //             }
    //             else {
    //                 return null
    //             }
    //             target_id = this.props.courseBuilder.lesson_id;
    //         }

    //     }

    // }

    getHeaderType = () => {
        if (this.props.courseBuilder.startingPoint === 'course') {
            return (
                <div className="big-wrap">
                    <div className="inner-wrap" style={{ justifyContent: 'center', display: 'flex' }}>
                        <div
                            className={"progress big-progress " + (this.props.baseComponent === 'course' ? 'active' : '')}
                            onClick={() => this.handleTopMenuClick('course')}
                        >
                            Course: {this.props.courseBuilder.CourseName}
                        </div>
                        <div
                            className={"progress big-progress " + (this.props.baseComponent === 'lesson' ? 'active' : '')}
                            onClick={() => this.handleTopMenuClick('lesson')}
                        >
                            Lesson: {this.props.courseBuilder.LessonName}
                        </div>
                        <div className={"progress big-progress " + (this.props.baseComponent === 'event' ? 'active' : '')}>
                            Event
                        </div>
                    </div>
                </div>
            )
        }
        return (
            <div className="big-wrap">
                <div className="inner-wrap" style={{ justifyContent: 'center', display: 'flex' }}>
                    <div
                        className={"progress big-progress " + (this.props.baseComponent === 'lesson' ? 'active' : '')}
                        onClick={() => this.handleTopMenuClick('lesson')}
                    >
                        Lesson: {this.props.courseBuilder.LessonName}
                    </div>
                    <div className={"progress big-progress " + (this.props.baseComponent === 'event' ? 'active' : '')}>
                        Event
                    </div>
                </div>
            </div>
        )
    }

    getLessonCycle = () => {
        let courseBuilder = this.props.courseBuilder;
        let activeWeek = courseBuilder.lessonListWeek;
        if ((this.props.baseComponent === 'lesson' || this.props.baseComponent === 'event') && courseBuilder.lessonCycleActive) {
            let cycleContent = courseBuilder.completedLessons
                .map((l, index) => {
                    if (l.WeekNum === activeWeek) {
                        if (l.lesson_id === courseBuilder.completedLessons[courseBuilder.lessonListIndex].lesson_id) {
                            let labelText = l.LessonName.substring(0, 14)
                            l.LessonName.length > 14 ? labelText += '...' : null
                            return (
                                <div key={index} className='progress active-progress'>{labelText}</div>
                            )
                        }
                        const lessonText = courseBuilder.courseUnscheduled === 1 ? index + 1 : <span>Day {l.DayOfWeek - 1}</span>
                        return (
                            <div key={index} onClick={() => this.newHandleClick(l, index)} className='progress'>{lessonText}</div>
                        )
                    }
                    else {
                        return null
                    }

                })
            return cycleContent
        }
        return null
    }

    handleWeekChange = (direction, weeks) => {
        const lessons = this.props.courseBuilder.completedLessons;
        const curWeek = this.props.courseBuilder.lessonListWeek;

        let findWeek = (el) => {
            return el === curWeek
        }

        if (direction === 'back') {
            const backWeek = weeks[weeks.findIndex(findWeek) - 1]
            const targetLesson = lessons.filter(l => l.WeekNum === backWeek)[0];
            const findLesson = (el) => { return el === targetLesson };
            const targetIndex = lessons.findIndex(findLesson)

            this.props.saveLesson(this.props.currentLesson, this.props.currentLessonAssignmentList, this.props.currentLessonQuizList, this.props.unscheduledEventList, this.props.auth.data.auth_id, this.props.companies)
            this.props.updateCourseBuilderParams({ LessonName: targetLesson.LessonName, lessonCycleRedirect: true, lessonListIndex: targetIndex, lessonListWeek: targetLesson.WeekNum })
            return this.props.history.push('/lesson/edit/' + targetLesson.lesson_id)
        }
        else {
            const nextWeek = weeks[weeks.findIndex(findWeek) + 1];
            const targetLesson = lessons.filter(l => l.WeekNum === nextWeek)[0];
            const findLesson = (el) => { return el === targetLesson };
            const targetIndex = lessons.findIndex(findLesson)

            this.props.saveLesson(this.props.currentLesson, this.props.currentLessonAssignmentList, this.props.currentLessonQuizList, this.props.unscheduledEventList, this.props.auth.data.auth_id, this.props.companies)
            this.props.updateCourseBuilderParams({ LessonName: targetLesson.LessonName, lessonCycleRedirect: true, lessonListIndex: targetIndex, lessonListWeek: targetLesson.WeekNum })
            return this.props.history.push('/lesson/edit/' + targetLesson.lesson_id)
        }
    }

    onWeekClick = (week) => {
        const lessons = this.props.courseBuilder.completedLessons;
        const targetLesson = lessons.filter(l => l.WeekNum === week)[0];
        const findLesson = (el) => { return el === targetLesson };
        const targetIndex = lessons.findIndex(findLesson)
        this.props.saveLesson(this.props.currentLesson, this.props.currentLessonAssignmentList, this.props.currentLessonQuizList, this.props.unscheduledEventList, this.props.auth.data.auth_id, this.props.companies)
        this.props.updateCourseBuilderParams({ LessonName: targetLesson.LessonName, lessonCycleRedirect: true, lessonListIndex: targetIndex, lessonListWeek: week })
        return this.props.history.push('/lesson/edit/' + targetLesson.lesson_id)
    }

    getWeekContent = () => {
        if (this.props.courseBuilder.completedLessons.length === 0 || !this.props.courseBuilder.lessonCycleActive || this.props.courseBuilder.courseUnscheduled === 1) {
            return null
        }
        const courseBuilder = this.props.courseBuilder;
        const weeks = [... new Set(courseBuilder.completedLessons.map(l => l.WeekNum))];
        const weekChoices = weeks.map(week => {
            return (
                <div onClick={() => this.onWeekClick(week)} className={courseBuilder.lessonListWeek === week ? 'weekblock-active' : 'weekblock'} key={week}>Week: {week}</div>
            )
        })

        return (
            <React.Fragment>
                <IconButton
                    disabled={courseBuilder.lessonListWeek === 1}
                    onClick={() => this.handleWeekChange('back', weeks)}
                    style={{ padding: '0px' }}
                >
                    <Icon>keyboard_arrow_left</Icon>
                </IconButton>
                {weekChoices}
                <IconButton
                    disabled={courseBuilder.lessonListWeek === weeks[weeks.length - 1]}
                    onClick={() => this.handleWeekChange('forward', weeks)}
                    style={{ padding: '0px' }}
                >
                    <Icon>keyboard_arrow_right</Icon>
                </IconButton>
            </React.Fragment>
        )

    }

    render() {
        const { auth, courseBuilder } = this.props;
        console.log(this.props)
        if (auth.role === 'student') {
            return (
                <div></div>
            )
        }
        const topHeader = this.getHeaderType()
        const lessonCycle = this.getLessonCycle()
        const weekContent = this.getWeekContent()

        return (
            <div style={{ width: '100%', height: '100%' }}>
                {topHeader}

                <div className="wrap">
                    <div className="inner-wrap" style={{ justifyContent: 'center', display: 'flex' }}>
                        {weekContent}
                    </div>
                </div>

                <div className="wrap">
                    <div className="inner-wrap" style={{ justifyContent: 'center', display: 'flex' }}>
                        {lessonCycle}
                    </div>
                </div>
            </div >
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        updateCourseBuilderParams: paramActions.updateCourseBuilderParams,
        saveLesson: lessonActions.saveLesson
    }, dispatch);
}

function mapStateToProps({ paramHistory, lessonApp, auth }) {
    return {
        courseBuilder: paramHistory.courseBuilder,
        currentLesson: lessonApp.lessons.currentLesson,
        currentLessonAssignmentList: lessonApp.lessons.currentLessonAssignmentList,
        currentLessonQuizList: lessonApp.lessons.currentLessonQuizList,
        unscheduledEventList: lessonApp.lessons.unscheduledEventList,
        auth: auth.user
    }
}

export default withRouter(withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(myStepper)));


// WEBPACK FOOTER //
// src/main/components/CourseBuilderHeader.js